import { render, staticRenderFns } from "./OpenDay.vue?vue&type=template&id=17b22280&scoped=true&"
import script from "./OpenDay.vue?vue&type=script&lang=js&"
export * from "./OpenDay.vue?vue&type=script&lang=js&"
import style0 from "./OpenDay.vue?vue&type=style&index=0&id=17b22280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b22280",
  null
  
)

export default component.exports